import React, { Component } from 'react';
import { Button, Col, Divider, Input, message, Popconfirm, Row, Table, Tabs } from 'antd';
import { connect } from 'react-redux';

import { saveFundsBook } from '@store/modules/funds_book';

// import { getAccountInfo } from "../../../store/modules/account_info";
import util from '@util';
import {
  queryDeleteFundsBook,
  queryDisableFundsBook,
  queryEnableFundsBook,
  queryFundsBookList,
} from '@api/finance/funds';
import ModalAdd from './ModalAdd';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      pageNo: 1,
      type: 0,
      total: 0,
      modalAddVisible: false,
      modalEditVisible: false,
      permission: {},
      defaultActiveKey: '',
    };
  }

  componentWillMount() {
    // this.props.dispatch(getAccountInfo());
  }

  componentDidMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  loadData = pageNo => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = this.state.condition || '';
    params.type = this.state.type || 0;
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryFundsBookList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          company: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 按条件搜索
   */
  search = () => {
    this.loadData();
  };

  delete = uuid => {
    const context = this;
    queryDeleteFundsBook(uuid).then(res => {
      if (res.statusCode === 200) {
        context.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 显示添加账户弹窗
   */
  showModalAdd = () => {
    this.setState({
      modalAddVisible: true,
    });
  };

  /**
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    this.uuid = uuid;
    this.setState({
      modalEditVisible: true,
    });
  };

  hideModal = () => {
    this.setState({
      modalAddVisible: false,
      modalEditVisible: false,
    });
  };

  /**
   * 新增账号
   */
  handAddSubmit = item => {
    saveFundsBook(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 编辑账号
   */
  handEditSubmit = item => {
    item.uuid = this.uuid;
    saveFundsBook(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  /**
   * 启用资金账户
   */
  handleEnable = uuid => {
    queryEnableFundsBook(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 禁用资金账户
   */
  handleDisable = uuid => {
    queryDisableFundsBook(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 切换标签页
   * @param {} key
   */
  callback = key => {
    this.setState(
      {
        type: key,
      },
      () => this.loadData(1),
    );
  };

  /**
   * 依据角色判断权限
   */
  judge = accountInfo => {
    const role = accountInfo.roles;
    const permission = {};
    let defaultActiveKey = [];
    role.map(sign => {
      if (sign === '[cash]') {
        permission.cash = true;
        defaultActiveKey.push('0');
      }

      if (sign === '[stock]') {
        permission.stock = true;
        defaultActiveKey.push('1');
      }

      if (sign === '[digitalCurrency]') {
        permission.digitalCurrency = true;
        defaultActiveKey.push('2');
      }

      return permission;
    });
    if (accountInfo.admin) {
      permission.all = true;
      defaultActiveKey.push('0');
    }

    defaultActiveKey = defaultActiveKey.sort();

    this.setState({
      permission,
      defaultActiveKey: defaultActiveKey[0],
    });
  };

  toDetail = (uuid, companyUuid) => {
    const { dispatch } = this.props;

    dispatch(
      saveFundsBook({
        companyUuid,
      }),
    );
    this.props.router.push(`/finance/funds/${uuid}/detail`);
  };

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        render: (text, record, index) => {
          const tot = 15 * (this.state.pageNo - 1) + index + 1;
          return <span>{tot}</span>;
        },
      },
      {
        title: '公司名称',
        dataIndex: 'companyName',
        key: 'companyName',
        render: (text, record) => {
          return (
            <a onClick={() => this.toDetail(record.uuid, record.companyUuid)}>{text}</a>
            // <Link
            //   to={`/finance/funds/${
            //     record.uuid
            //   }/detail`}
            // >
            //   {text}
            // </Link>
          );
        },
      },
      {
        title: `年初余额`,
        dataIndex: 'initBalance',
        key: 'initBalance',
        render: (text, record) => {
          return (
            <span>
              {util.numberFormat(text, 2, '.', ',')}
              {record.unit ? `(${record.unit})` : '(元)'}
            </span>
          );
        },
      },
      {
        title: `余额`,
        dataIndex: 'current',
        key: 'current',
        render: (text, record) => {
          return (
            <span>
              {util.numberFormat(text, 2, '.', ',')}
              {record.unit ? `(${record.unit})` : '(元)'}
            </span>
          );
        },
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          return (
            <span>
              {record.isEnable === 0 ? (
                <Popconfirm
                  placement="leftTop"
                  title="确定启用此资金账户吗？"
                  onConfirm={() => this.handleEnable(record.uuid)}
                  okText="确定"
                  cancelText="取消"
                >
                  <a>启用</a>
                </Popconfirm>
              ) : (
                <span>
                  <Popconfirm
                    placement="leftTop"
                    title="确定禁用此资金账户吗？"
                    onConfirm={() => this.handleDisable(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>禁用</a>
                  </Popconfirm>
                  <Divider type="vertical" />

                  <a onClick={() => this.toDetail(record.uuid, record.companyUuid)}>详情</a>
                  <span>
                    <Divider type="vertical" />
                    <a onClick={() => this.showModalEdit(record.uuid)}>编辑</a>
                  </span>
                </span>
              )}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { total, company, isLoading } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const { permission, defaultActiveKey } = this.state;

    return (
      <div>
        <div className="fixed-header" style={{ minWidth: '800px' }}>
          <Row type="flex" justify="space-between">
            <Col>
              <Button icon="plus" style={{ marginBottom: 15 }} onClick={this.showModalAdd}>
                添加
              </Button>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入关键字"
                style={{ width: '300px' }}
                value={this.state.condition}
                onChange={this.setCondition}
              />
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.search}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>

        <div>
          <Tabs
            defaultActiveKey={defaultActiveKey}
            onChange={this.callback}
            style={{ paddingTop: '46px' }}
          >
            <TabPane tab="现金帐" key="0" disabled={!(permission.all || permission.cash)}>
              <Table
                rowKey={record => record.uuid}
                rowSelection={{}}
                columns={this.columns()}
                dataSource={company}
                pagination={pagination}
                loading={isLoading}
              />
            </TabPane>
            <TabPane tab="股票" key="1" disabled={!(permission.all || permission.stock)}>
              <Table
                rowKey={record => record.uuid}
                rowSelection={{}}
                columns={this.columns()}
                dataSource={company}
                pagination={pagination}
                loading={isLoading}
              />
            </TabPane>
            <TabPane
              tab="虚拟货币"
              key="2"
              disabled={!(permission.all || permission.digitalCurrency)}
            >
              <Table
                rowKey={record => record.uuid}
                rowSelection={{}}
                columns={this.columns()}
                dataSource={company}
                pagination={pagination}
                loading={isLoading}
              />
            </TabPane>
          </Tabs>
        </div>

        {this.state.modalAddVisible ? (
          <ModalAdd
            handSubmit={this.handAddSubmit}
            data={{}}
            cancel={this.hideModal}
            permission={permission}
          />
        ) : (
          ''
        )}
        {this.state.modalEditVisible ? (
          <ModalAdd
            handSubmit={this.handEditSubmit}
            data={{}}
            uuid={this.uuid}
            cancel={this.hideModal}
            permission={permission}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/funds/Index.js